export default __webpack_public_path__ + "static/cafe_36053-f3aceb5f0022ae1ae7527e01fe20c526.png";